import { loggedNavbarItems } from "../../routes/navBarItems";
import { useContext, useEffect, useRef, useState } from "react";
import {
  Link,
  useLocation,
  useNavigate,
} from "react-router-dom";
import { NavbarItems } from "./types";
import styles from "./navbar.module.scss";
import LoggedMobileNavbar from "../MobileNavbar/LoggedMobileNavbar";
import AuthClient from "../../api/AuthClient";
import { routes } from "../../routes/routes";
import { CitiesInfoContext } from "../../AllCitiesContext";
import { LoadingAnimationContext } from "../../GlobalContext/loadingAnimation";
import AppMode from "../../api/enums/AppMode";
import { getStoredAppMode, isPromoterUserType, setStoredAppMode } from "../../utils/appMode";
import { getCurrentCity } from "../../utils/currentCity";

interface NavigationBarProps {
  navbarItems: NavbarItems[];
  handleLogout: () => void;
}

export default function LoggedNavigationBar(props: NavigationBarProps) {
  const location = useLocation();
  const activePage = location.pathname;
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement | null>(null);
  const authClient = new AuthClient();
  const user = authClient.getAuthenticationResponse();

  const userType = user?.userType.toString();
  const handleLogout = () => {
    props.handleLogout();
  };
  const navigate = useNavigate();
  const isOnGuestRoute = getStoredAppMode() === AppMode.GuestMode;

  const handleModeSwitch = () => {
    const nextMode = isOnGuestRoute ? AppMode.PromoterMode : AppMode.GuestMode;
    setStoredAppMode(nextMode);
    navigate(nextMode === AppMode.PromoterMode ? routes.PromotersMode : routes.GuestMode);
    setIsOpen(false);
  };

  const [cityName, setCityName] = useState<string>("");
  const { selectedCity } = useContext(CitiesInfoContext)
  const { setAlsoGoingOutHasLoadedOnce } = useContext(LoadingAnimationContext);

  useEffect(() => {
    const authClient = new AuthClient();
    const authenticationResponse = authClient.getAuthenticationResponse();
    const currentCity = getCurrentCity(authenticationResponse);

    if (currentCity) {
      setCityName(currentCity.cityName);
      setAlsoGoingOutHasLoadedOnce(false);
    }
  }, [selectedCity, setAlsoGoingOutHasLoadedOnce]);

  useEffect(() => {
    if (!isOpen) {
      return;
    }

    const handleOutsideInteraction = (event: MouseEvent | TouchEvent) => {
      if (!dropdownRef.current) {
        return;
      }

      if (!dropdownRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleOutsideInteraction);
    document.addEventListener("touchstart", handleOutsideInteraction);

    return () => {
      document.removeEventListener("mousedown", handleOutsideInteraction);
      document.removeEventListener("touchstart", handleOutsideInteraction);
    };
  }, [isOpen]);


  return (
    <>
      <div className={styles.dropdown} ref={dropdownRef}>
        <button className={styles.dropbtn} onClick={() => setIsOpen(!isOpen)}>
          {user?.firstName} {user?.lastName}
        </button>
        {isOpen && (
          <ul className={styles.dropdownContent}>
            {props.navbarItems.map((item) => (
              <li
                className={
                  activePage === item.path
                    ? styles.navbarActiveItem
                    : styles.navbarItem
                }
                key={item.path}
                onClick={() => {
                  setIsOpen(false);
                }}
              >
                <Link to={item.path}>{item.path === routes.CitySelector ? cityName : item.title}</Link>
              </li>
            ))}

           {isPromoterUserType(userType) && (
              <li
                className={styles.navbarItem}
                onClick={handleModeSwitch}
              >
                <a>
                  {isOnGuestRoute ? "Switch to Promoter Mode" : "Switch to Guest Mode"}
                </a>
              </li>
            )}

            <li className={styles.navbarItem}>
              <button
                type="button"
                className={styles.logoutButton}
                onClick={() => {
                  handleLogout();
                  setIsOpen(false);
                }}
              >
                Log Out
              </button>
            </li>
          </ul>
        )}
      </div>

      <LoggedMobileNavbar
        navLinkItem={loggedNavbarItems}
        handleLogout={handleLogout}
        cityName={cityName}
      />
    </>
  );
}
